/**
 * Web build of the download manager: offline downloads are native-only, and
 * the background downloader package must never be evaluated in the browser
 * bundle. Metro picks this file for `web`; every entry point is a no-op.
 */
import type { LessonPageData } from '@/supabase/services/lessonOptimized';
import type { LessonVideo } from '@/types';
import type { DownloadRecord } from './types';

export interface StartDownloadParams {
  pageData: LessonPageData;
  video: LessonVideo;
  userId: string;
}

export function configureDownloads(): void {}

export async function startDownload(_params: StartDownloadParams): Promise<DownloadRecord> {
  throw new Error('Downloads are only available in the app');
}

export async function retryDownload(_lessonVideoId: number): Promise<void> {}
export async function pauseDownload(_lessonVideoId: number): Promise<void> {}
export async function resumeDownload(_lessonVideoId: number): Promise<void> {}
export async function deleteDownload(_lessonVideoId: number, _reason: 'user' | 'system' = 'user'): Promise<void> {}
export async function deleteAllDownloads(): Promise<void> {}
export function getStorageUsedBytes(): number {
  return 0;
}
export async function reattachDownloads(): Promise<void> {}
export async function verifyDownloadEntitlements(_userId: string, _force = false): Promise<void> {}
